import React from 'react'
import { connect } from 'react-redux'
import BrandActions from '../../Redux/BrandRedux'
import { currentBranch } from '../../Utils/PrivilegeUtils'

class CreateBrand extends React.Component {
  constructor (props) {
    super(props)
    this.branch = currentBranch()
    this.state = {
      form: {
        name: ''
      }
    }
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let data = { ...this.state.form }
    data.iso_code = this.branch
    this.props.createBrand(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Create Brand</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Brand</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                placeholder='Brand Name'
                className='form-control'
                value={this.state.form.name}
                onChange={(event) => this._inputChange(event, 'name')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  createBrand: (data) => dispatch(BrandActions.createBrandRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CreateBrand)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/CreateBrand.js